import { z } from 'zod';

import { EventEnum } from '../enums';

export const CreateEventReqTransformer = z.object({
  event: z.nativeEnum(EventEnum),
});
